import { Alert, Button, Stack, Title } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import { useGetAssetsV2Summary } from "../queries/useGetAssetsV2Summary";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import { AssetsV2Dashboard } from "./AssetsV2Dashboard";
import { AssetsV2Loading } from "./snowflakes/AssetsV2Loading";

export function AssetsV2Overview({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { t } = useTranslation();
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data, isPending, isError, refetch } = useGetAssetsV2Summary(
    customer.customerId,
  );
  return (
    <Stack gap={24}>
      <Title as="h1" size="xl">
        {t("enterprise.assetsV2.pageTitle")}
      </Title>
      {isPending ? <AssetsV2Loading /> : null}
      {isError ? (
        <Alert
          tone="negative"
          title={t("enterprise.assetsV2.loadErrorTitle")}
          subtext={t("enterprise.assetsV2.loadErrorDescription")}
          action={
            <Button size="sm" onClick={() => void refetch()}>
              {t("enterprise.assetsV2.retry")}
            </Button>
          }
        />
      ) : null}
      {data && data.summary.monitoredAssetCount === 0 ? (
        <Alert
          tone="informative"
          title={t("enterprise.assetsV2.emptyTitle")}
          subtext={t("enterprise.assetsV2.emptyDescription")}
        />
      ) : null}
      {data && data.summary.monitoredAssetCount > 0 ? (
        <AssetsV2Dashboard customerId={customer.customerId} response={data} />
      ) : null}
    </Stack>
  );
}
